import { Component, Input } from "@angular/core";
import {
  CategorySource,
  CategorySourceEnum,
} from "@bitwarden/web-vault/app/models/types/category.types";

@Component({
  selector: "app-category-source-badge",
  templateUrl: "./category-source-badge.component.html",
})
export class CategorySourceBadgeComponent {
  @Input() source: CategorySource;

  get isManual(): boolean {
    return this.source === CategorySourceEnum.manual;
  }
}
